import axios from 'axios/index';

import { REFRESH_TOKEN } from 'constants/system'; // @TODO - JWT_REFRESH // later

import { RefreshEndpoint } from 'core/axios/constants';
import logout from 'core/axios/logout';

import { getCookie } from 'utils/cookies';

const JWT_REFRESH_KEY =
  sessionStorage.getItem(`SESSION_${REFRESH_TOKEN}_KEY`) || REFRESH_TOKEN;

const refreshJWT = async () => {
  try {
    const refreshToken = getCookie(JWT_REFRESH_KEY);
    // @TODO
    // browsers now construct and send an OPTIONS request automatically for cross-origin requests
    // our API expects either a CSRF or a refresh token in the OPTIONS request
    // we have no control over those, and cannot communicate with the refresh endpoint
    const newTokenResponse = await axios.post(
      RefreshEndpoint,
      {},
      {
        headers: {
          Authorization: `bearer ${refreshToken}`,
        },
        withCredentials: true,
      },
    );
    const payload = newTokenResponse || {};
    if (payload?.status === 200) {
      return payload.data.jwt;
    }
    logout();
  } catch (e) {
    logout();
  }
  return null;
};

export default refreshJWT;
